import Head from 'next/head';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

import { CommonHead } from '@app/components/CommonHead';
import { Footer } from '@app/components/Footer';
import Header from '@app/components/home/Header';
import { AuthState, useAuth } from '@app/hooks/useAuth';

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const { isAuth } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (isAuth === AuthState.AUTH) {
      router.replace('/');
    }
  }, [isAuth]);

  return (
    <>
      <CommonHead />

      <div className="min-h-screen bg-white flex flex-col text-gray-900">
        <Header enableBackButton={false} />

        {/* Main Content */}
        <main className="flex flex-col grow-1 border-t border-gray-200 justify-center items-center">
          {children}
        </main>

        <Footer showFull={false} />
      </div>
    </>
  );
};

export default AuthLayout;
